import React from 'react';
import {
  MDBCard,
  MDBCardImage,
  MDBCardTitle,
  MDBCardHeader,
  MDBCardText,
  MDBCardFooter
} from 'mdb-react-ui-kit';
import { NavLink } from 'react-router-dom';

export default function Card({ Id,Titulo, Descripcion, Imagen, Precio }) {

  return (

    <NavLink to={"/Tienda/"+Id}>

      <MDBCard className='h-100 square border border-2 rounded-6' alignment='center'>
        <MDBCardHeader>
          <MDBCardTitle className='text-muted fs-3'>{Titulo}</MDBCardTitle>
        </MDBCardHeader>
        <MDBCardImage
          src={require(Imagen + "")}
          alt={"Img/" + Imagen + "/"}
          position='top'
          height={300}
          className='square border border-1 p-2'
        />
        <MDBCardText className='text-muted p-1'>
          {Descripcion}
        </MDBCardText>
        <MDBCardFooter>
          <MDBCardTitle className='text-muted fs-3'>
            {Precio}
          </MDBCardTitle>
        </MDBCardFooter>
      </MDBCard>
    </NavLink>
  
  );
  
}